<template>
    <main>
        <Navbar />
        <div class="main">
            <div class="container">
                <form @submit.prevent="liveParams">
                    <div class="form-group">
                        <label class="text-white" for="id">Bloquear eventos</label>
                        <select class="form-control" v-model="block_events" :disabled="block" required>
                            <option value="sim" :selected="block_events == 'sim'">Sim</option>
                            <option value="nao" :selected="block_events == 'nao'">Não</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="opcao-id">Bloquear mercados</label>
                        <select class="form-control" v-model="block_markets" :disabled="block" required>
                            <option value="sim" :selected="block_markets == 'sim'">Sim</option>
                            <option value="nao" :selected="block_markets == 'nao'">Não</option>
                        </select>
                    </div>
                    <div class="form-group" v-for="(item, index) in events_ids" :key="index" :data-id="item.id">
                        <div class="row align-items-center" :class="{'bg-dark pt-3 pb-3': platform == 'mobile'}">
                            <div class="col text-truncate">
                                <label :for="`option-${index}`" class="text-light">ID:</label>
                                <input type="text" class="form-control" v-model="events_ids[index].id" v-number-only :id="`id-${index}`" autocomplete="off" spellcheck="false" required>
                            </div>
                            <div class="w-100 mb-3" v-if="platform == 'mobile'"></div>
                            <div class="col text-truncate">
                                <label :for="`option-quotation-${index}`" class="text-light">Novo ID:</label>
                                <input type="text" class="form-control" v-model="events_ids[index].newId" v-number-only :id="`new-id-${index}`" autocomplete="off" spellcheck="false" required>
                            </div>
                            <div class="w-100 mb-3" v-if="platform == 'mobile'"></div>
                            <div :class="platform == 'desktop' ? 'col-auto' : 'col-12'">
                                <div class="row align-items-center" :class="{'mt-32px': platform == 'desktop'}">
                                    <div class="col">
                                        <a class="btn btn-success btn-block text-light" @click="increment">
                                            <i class="fas fa-plus mr-2"></i>1 opção
                                        </a>
                                    </div>
                                    <div class="col">
                                        <a class="btn btn-danger btn-block text-light" @click="disagrees">
                                            <i class="fas fa-minus mr-2"></i>1 opção
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col">
                            <button type="submit" class="btn btn-block btn-success" :disabled="block">
                                <i class="fas fa-save mr-2"></i>Salvar
                            </button>
                        </div>
                        <div class="col">
                            <a class="btn btn-block btn-danger" @click="cancel" :class="{'disabled': block}">
                                <i class="fas fa-ban mr-2"></i>Cancelar
                            </a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </main>
</template>

<script>
import {api} from '../api'
import Navbar from './Navbar'
import Swal from 'sweetalert2'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    data() {
        return {
            block: true,
            loading: false,
            event_id: {},
            events_ids: [{
                id: '',
                newId: ''
            }],
            set_options: 0,
            block_events: 'nao',
            block_markets: 'nao',
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			},
            platform: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop'
        }
    },
    components: {
        Navbar,
        Loading
    },
    methods: {
        liveParams() {

            const self = this;
            const event_id = self.events_ids.reduce((a, v) => ({ ...a, [parseInt(v.newId)]: parseInt(v.id)}), {});

            Swal.fire({
                title: 'Confirmação',
                html: `Você deseja salvar as alterações?`,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Sim'
            }).then((result) => {

                if (result.value) {

                    self.loading = true;

                    api.put('get-params-live', {
                        event_id: event_id,
                        block_events: self.block_events,
                        block_markets: self.block_markets
                    }).then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                Swal.fire(
                                    'Parabéns!',
                                    'As alterações foram salvas com sucesso!',
                                    'success'
                                );
                            break;
                            default:
                                Swal.fire(
                                    'Atenção!',
                                    response.data.message,
                                    'warning'
                                );
                            break;
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'warning'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'warning'
                            );
                        }
                    }).finally(() => {
                        self.loading = false
                    });
                }
            });
        },
        getLiveParams() {

            const self = this;

            self.loading = true;

            api.get('get-params-live').then((response) => {
                switch(response.data.result) {
                    case 'success':
                        self.event_id = response.data.alternative_event_id || {};
                        self.block_events = response.data.block_events ? 'sim' : 'nao';
                        self.block_markets = response.data.block_markets ? 'sim' : 'nao';
                    break;
                    default:
                        Swal.fire(
                            'Atenção!',
                            response.data.message,
                            'warning'
                        );
                    break;
                }
            }).catch((error) => {
                try {
                    Swal.fire(
                        'Falha',
                        self.network_erros[error.status]['message'],
                        'warning'
                    );
                } catch(e) {
                    Swal.fire(
                        'Falha',
                        self.network_erros[408]['message'],
                        'warning'
                    );
                }
            }).finally(() => {
                self.loading = false
            });
        },
        cancel() {
            this.set_options = 0;
            this.events_ids = [{
                id: '',
                newId: ''
            }];
        },
        increment() {
            this.set_options++;
        },
        disagrees() {
            this.set_options--;
        },
    },
    directives: {
        numberOnly: {
            bind: (el) => {
                el.handler = () => {
                    el.value = el.value.replace(/\D/g,"").replace(/[^0-9]+/gi,'');
                }
                el.addEventListener('input', el.handler)
            },
            unbind: (el) => {
                el.removeEventListener('input', el.handler)
            }
        }
    },
    watch: {
        set_options(value) {

            if (value < 0 || !value) {
                this.set_options = 0;
            } else {
                // this.events_ids = [];

                for (let i = 1; i <= value; i++) {

                    if (this.events_ids.length < 100) {
                        this.events_ids.push({
                            id: '',
                            newId: ''
                        });
                    }
                }
            }
        },
        event_id(values) {
            
            if (Object.keys(values).length == 0) return;
            
            this.events_ids = [];

            for (let key in values) {
                this.events_ids.push({
                    id: key,
                    newId: values[key]
                });
            }
        }
    },
    beforeMount() {
        try {
            const {pipe} = JSON.parse(localStorage.getItem('auth'));
            this.block = pipe == 1 ? false : true;
        } catch(e) {
            this.block = false;
        }
    },
    created() {
        this.getLiveParams();
    }
}
</script>

<style lang="css" scoped>
.mt-32px {
    margin-top: 32px;
}
</style>